<table mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="idItemPlano">
    <th mat-header-cell *matHeaderCellDef>#</th>
    <td mat-cell data-label="#" *matCellDef="let row">{{ row.idItemPlano }}</td>
  </ng-container>
  <ng-container matColumnDef="descricaoItemPlano">
    <th mat-header-cell *matHeaderCellDef>Descrição</th>
    <td mat-cell data-label="Descrição" *matCellDef="let row">{{ row.descricaoItemPlano }}</td>
  </ng-container>
  <ng-container matColumnDef="cargaHorariaPrevista">
    <th mat-header-cell *matHeaderCellDef>Carga horária prevista</th>
    <td mat-cell data-label="Carga horária prevista" *matCellDef="let row">{{ row.cargaHorariaPrevista }}</td>
  </ng-container>
  <ng-container matColumnDef="cargaHorariaEfetiva">
    <th mat-header-cell *matHeaderCellDef>Carga horária efetiva</th>
    <td mat-cell data-label="Carga horária efetiva" *matCellDef="let row">{{ row.cargaHorariaEfetiva }}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
  <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
</table>
